export default __webpack_public_path__ + "static/media/puzzleClue4.6d3f0f82.png";